import { useEffect, useState } from 'react';

export function getTenantLogoSource(orgName, logoUrl) {
  const supplied = typeof logoUrl === 'string' ? logoUrl.trim() : '';
  if (supplied && (/^https?:\/\//i.test(supplied) || supplied.startsWith('/') || /^data:image\/(png|jpeg|jpg|webp|gif|svg\+xml);/i.test(supplied))) {
    return supplied;
  }
  // Osabea's public, official static logo is a last resort ONLY for the
  // Osabea tenant. Other workspaces must never inherit Osabea branding.
  return /\bosabea\b/i.test(String(orgName || '')) ? '/osabea_logo.png' : null;
}

export default function TenantBrandMark({ orgName, logoUrl, className = '' }) {
  const [failedSource, setFailedSource] = useState(null);
  const imageSrc = getTenantLogoSource(orgName, logoUrl);
  useEffect(() => { setFailedSource(null); }, [imageSrc]);
  const initials = String(orgName || 'Organisation')
    .split(/\s+/).filter(Boolean).slice(0, 2).map(word => word[0]?.toUpperCase()).join('') || 'O';
  return (
    <span
      className={`inline-flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-white text-xs font-bold text-primary ${className}`}
      data-testid="tenant-brand-mark"
    >
      {imageSrc && failedSource !== imageSrc ? (
        <img
          src={imageSrc}
          alt={`${orgName || 'Organisation'} logo`}
          className="h-full w-full object-contain p-0.5"
          onError={() => setFailedSource(imageSrc)}
        />
      ) : <span aria-label="Organisation initials">{initials}</span>}
    </span>
  );
}
